import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SocketLogService } from 'src/app/services/socket-log.service';

@Component({
  selector: 'app-log-viewer',
  templateUrl: './log-viewer.component.html',
  styleUrls: ['./log-viewer.component.css']
})
export class LogViewerComponent implements OnInit, OnDestroy {
  logs: string[] = [];
  private logSub: Subscription;

  // Nueva lógica para múltiples logs
  logSources = ['onDemand', 'apiAvanti', 'sockets', 'wsp', 'mailing', 'carga', 'tbk', 'middlewares', 'snabb', 'mercadoPago'];
  activeSource = 'apiAvanti';

  constructor(private socketLogService: SocketLogService) {}

  ngOnInit(): void {
    this.subscribeToLog(this.activeSource);
  }

  subscribeToLog(source: string): void {
    this.logs = [];
    if (this.logSub) this.logSub.unsubscribe();
    this.logSub = this.socketLogService.onLog(source as any).subscribe((line) => {
      this.logs.push(line);
      if (this.logs.length > 300) this.logs.shift();
    });
  }

  onSourceChange(source: string): void {
    this.activeSource = source;
    this.subscribeToLog(source);
  }

  filters = {
    ERROR: true,
    LISTAR: true,
    INFO: true,
    SYSTEM: true,
    MIDDLEWARES: true,
    SOCKETS: true,
    INSERT: true,
    UPDATE: true,
    DELETE: true,
    DOCTOR: true,
    PACIENTE: true
  };

  filterKeys: { key: keyof typeof this.filters, label: string }[] = [
    { key: 'ERROR', label: 'ERROR' },
    { key: 'LISTAR', label: 'LISTAR' },
    { key: 'INFO', label: 'INFO' },
    { key: 'SYSTEM', label: 'SYSTEM' },
    { key: 'MIDDLEWARES', label: 'MIDDLEWARES' },
    { key: 'SOCKETS', label: 'SOCKETS' },
    { key: 'INSERT', label: 'INSERT' },
    { key: 'UPDATE', label: 'UPDATE' },
    { key: 'DELETE', label: 'DELETE' },
    { key: 'DOCTOR', label: 'DOCTOR' },
    { key: 'PACIENTE', label: 'PACIENTE' }
  ];

  getFilteredLogs(): string[] {
    return this.logs.filter(line => {
      if (this.filters.ERROR && line.includes('[ERROR]')) return true;
      if (this.filters.LISTAR && line.includes('[LISTAR]')) return true;
      if (this.filters.INFO && line.includes('[INFO]')) return true;
      if (this.filters.SYSTEM && line.includes('[SYSTEM]')) return true;
      if (this.filters.MIDDLEWARES && line.includes('[MIDDLEWARES]')) return true;
      if (this.filters.SOCKETS && line.includes('[SOCKETS]')) return true;
      if (this.filters.INSERT && line.includes('[INSERT]')) return true;
      if (this.filters.UPDATE && line.includes('[UPDATE]')) return true;
      if (this.filters.DELETE && line.includes('[DELETE]')) return true;
      if (this.filters.DOCTOR && line.includes('[DOCTOR]')) return true;
      if (this.filters.PACIENTE && line.includes('[PACIENTE]')) return true;
      return false;
    });
  }

  clearLogs(): void {
    this.logs = [];
  }

  downloadLog(): void {
    const blob = new Blob([this.logs.join('\n')], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `log-${this.activeSource}-${new Date().toISOString()}.txt`;
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  getLogLevelClass(line: string): string {
    if (line.includes('[ERROR]')) return 'log-error';
    if (line.includes('[LISTAR]')) return 'log-listar';
    if (line.includes('[INFO]')) return 'log-info';
    if (line.includes('[SYSTEM]')) return 'log-system';
    if (line.includes('[MIDDLEWARES]')) return 'log-middlewares';
    if (line.includes('[SOCKETS]')) return 'log-sockets';
    if (line.includes('[INSERT]')) return 'log-insert';
    if (line.includes('[UPDATE]')) return 'log-update';
    if (line.includes('[DELETE]')) return 'log-delete';
    if (line.includes('[DOCTOR]')) return 'log-doctor';
    if (line.includes('[PACIENTE]')) return 'log-paciente';
    return 'log-default';
  }

  ngOnDestroy(): void {
    this.logSub?.unsubscribe();
    this.socketLogService.disconnect();
  }
}
